import React, { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api, { arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import { Progress } from "@/components/ui/progress";
import { TableSkeleton } from "@/components/common/Loading";

function Bar({ label, pct }) {
  const color = pct >= 90 ? "bg-red-500" : pct >= 70 ? "bg-amber-500" : "bg-brand-500";
  return (
    <div className="w-40">
      <div className="mb-1 flex justify-between text-xs"><span className="text-slate-500">{label}</span><span className="font-semibold text-slate-700">{pct}%</span></div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100"><div className={`h-full rounded-full ${color}`} style={{ width: `${Math.min(pct, 100)}%` }} /></div>
    </div>
  );
}

export default function Usage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/usage").then(({ data }) => setRows(arr(data))); }, []);
  if (!rows) return <div className="space-y-6"><PageHeader title="Usage" /><TableSkeleton /></div>;

  return (
    <div className="space-y-6">
      <PageHeader title="Usage" subtitle="Monthly usage per client against plan limits" icon={Activity} />
      <div className="card-surface overflow-x-auto p-0 scrollbar-thin">
        <table className="w-full min-w-[700px]">
          <thead><tr className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
            <th className="px-4 py-3">Client</th><th className="px-4 py-3">Plan</th><th className="px-4 py-3">Posts</th><th className="px-4 py-3">Review Requests</th><th className="px-4 py-3">AI Replies</th>
          </tr></thead>
          <tbody className="divide-y divide-slate-50">
            {rows.map((r) => (
              <tr key={r.id} className="text-sm">
                <td className="px-4 py-3 font-semibold text-slate-800">{r.businessName}</td>
                <td className="px-4 py-3 text-slate-600">{r.plan}</td>
                <td className="px-4 py-3"><Bar label={`${r.usage.posts}/${r.limits.posts}`} pct={r.postsPct} /></td>
                <td className="px-4 py-3"><Bar label={`${r.usage.reviewRequests}/${r.limits.reviewRequests}`} pct={r.requestsPct} /></td>
                <td className="px-4 py-3"><Bar label={`${r.usage.aiReplies}/${r.limits.aiReplies}`} pct={r.aiPct} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
